const KEY = 'saloni_order_success_v1';

export function saveOrderSuccessPayload(payload) {
  try {
    sessionStorage.setItem(
      KEY,
      JSON.stringify({
        ...payload,
        placedAt: Date.now(),
      })
    );
  } catch {
    /* ignore quota */
  }
}

/** Recent order placed in this browser session (avoids false “empty bag” after checkout). */
export function readRecentOrderSuccess(maxAgeMs = 5 * 60 * 1000) {
  const payload = readOrderSuccessPayload();
  if (!payload?.orderNumber) return null;
  const placedAt = Number(payload.placedAt) || 0;
  if (placedAt > 0 && Date.now() - placedAt > maxAgeMs) return null;
  return payload;
}

export function readOrderSuccessPayload() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearOrderSuccessPayload() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
